import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{
    ids: string[];
}>;

export const DispatchToggleSelectedAccessorials: HandlerType = props => {
    props.dispatch({
        type: "Custom/Accessorials/ToggleSelectedAccessorials",
        ids: props.parameter.ids,
    });
};

export const chain = [DispatchToggleSelectedAccessorials];

const selectAccessorials = createHandlerChainRunner(chain, "SelectAccessorials");
export default selectAccessorials;
